import { Fitter } from '@sc/data-access-models';

export class FittersAddedAction {
  static readonly type = '[Fitters] Added';
  constructor(public fitters: Fitter[], public merge = true) {}
}

export class FittersClearedAction {
  static readonly type = '[Fitters] Cleared';
}

export class FittersRemoveAction {
  static readonly type = '[Fitters] Removed';
  constructor(public fittersToRemove: string[]) {}
}
